// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const sroOperations = {
  getSroHealth: ['get', '/sro/health'] as const,
  putSroUpdateuser: ['put', '/sro/updateuser'] as const,
  postSroCreateuser: ['post', '/sro/createuser'] as const,
  getSroFunctionalgroupcode: ['get', '/sro/functionalgroupcode'] as const,
  getSroCommodity: ['get', '/sro/commodity'] as const,
  getSroCountries: ['get', '/sro/countries'] as const,
  getSroCountriesByCountryCode: [
    'get',
    '/sro/countries/{countryCode}'
  ] as const,
  getSroResponsibilities: ['get', '/sro/responsibilities'] as const,
  getSroCommodityCodes: ['get', '/sro/commodityCodes'] as const,
  postSroAllByPageNum: ['post', '/sro/all/{pageNum}'] as const,
  getSroByTypeUsers: ['get', '/sro/{type}/users'] as const,
  postSroByType: ['post', '/sro/{type}'] as const,
  getSroByTypeByFuncGroupCdUsers: [
    'get',
    '/sro/{type}/{funcGroupCd}/users'
  ] as const,
  getSroBySupplierNumber: ['get', '/sro/{supplierNumber}'] as const,
  postSroInternalCountries: ['post', '/sro/internal/countries'] as const,
  postSroInternalCountriesByCountryCode: [
    'post',
    '/sro/internal/countries/{countryCode}'
  ] as const,
  deleteSroInternalCountriesByCountryCode: [
    'delete',
    '/sro/internal/countries/{countryCode}'
  ] as const,
  getSroInternalCommodities: ['get', '/sro/internal/commodities'] as const,
  postSroInternalCommodities: ['post', '/sro/internal/commodities'] as const,
  postSroInternalCommoditiesByCommodityCodeByResponsibilityCode: [
    'post',
    '/sro/internal/commodities/{commodityCode}/{responsibilityCode}'
  ] as const,
  deleteSroInternalCommoditiesByCommodityCodeByResponsibilityCode: [
    'delete',
    '/sro/internal/commodities/{commodityCode}/{responsibilityCode}'
  ] as const,
  postSroInternalSearchExport: ['post', '/sro/internal/search/export'] as const,
  postSroInternalSearchByPageNum: [
    'post',
    '/sro/internal/search/{pageNum}'
  ] as const,
  postSroInternalRecord: ['post', '/sro/internal/record'] as const,
  patchSroInternalRecordBySupplierNumber: [
    'patch',
    '/sro/internal/record/{supplierNumber}'
  ] as const,
  getSroInternalPermissions: ['get', '/sro/internal/permissions'] as const,
  postSroInternalMassupload: ['post', '/sro/internal/massupload'] as const
} as const;
